import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateService } from '@ngx-translate/core';
import { combineLatest } from 'rxjs';

const rangeFields = ['from', 'to'];

@Component({
  selector: 'om-time-range',
  templateUrl: './om-time-range.component.html',
  styleUrls: []
})
@UntilDestroy()
export class OmTimeRangeComponent implements OnInit {
  @Input() label: string;
  @Input() fromPlaceholder?: string;
  @Input() toPlaceholder?: string;
  @Input() control: FormGroup;
  @Input() deletable: boolean = true;
  @Input() required: boolean = false;
  @Input() icon: string;

  @Output() close: EventEmitter<Event> = new EventEmitter<Event>();

  constructor(private _translateService: TranslateService, private _fb: FormBuilder) {}

  ngOnInit(): void {
    this.control = this.control ?? this._buildEmptyTimelapseGroup();

    if (!this.fromPlaceholder) {
      this.fromPlaceholder = this._translateService.instant('SETTINGS.CALENDARS_SETTINGS.FROM_TIME');
    }
    if (!this.toPlaceholder) {
      this.toPlaceholder = this._translateService.instant('SETTINGS.CALENDARS_SETTINGS.TO_TIME');
    }

    if (this.required) {
      rangeFields.forEach((key) => this.control.get(key).addValidators(Validators.required));
    }

    combineLatest([this.control.get('from').valueChanges, this.control.get('to').valueChanges])
      .pipe(untilDestroyed(this))
      .subscribe(([from, to]) => {
        this.control.markAllAsTouched();
        if (from > to) {
          const error = { invalid: true, invalidTimeRange: { value: this.control.get('from').value } };
          this.control.get('to').setErrors({ invalid: true });
          this.control.get('from').setErrors(error);
        } else {
          this.control.get('from').setErrors(null);
          this.control.get('to').setErrors(null);
        }
      });

    ['from', 'to'].forEach((key) =>
      this.control
        .get(key)
        .valueChanges.pipe(untilDestroyed(this))
        .subscribe((value) => {
          this.control.get(key).setErrors(!!value ? null : { invalid: true });
          this.control.get(key).markAsDirty();
          this.control.get(key).updateValueAndValidity({ emitEvent: false });
        })
    );
  }

  _emitClose(event: Event): void {
    this.close.emit(event);
  }

  private _buildEmptyTimelapseGroup(): FormGroup {
    const mockTime: String = '00:00:00';
    const group: FormGroup = this._fb.group({});
    rangeFields.forEach((key) => group.addControl(key, this._fb.control(mockTime, Validators.required)));
    return group;
  }
}
